<template>
  <div class="flex-1 flex flex-col items-center justify-center">
    <h1 class="mb-05">InkZone translation tool</h1>

    <section class="flex flex-wrap space-around">
      <router-link
        v-for="code in languages"
        :key="code"
        :to="`/${code}`"
        class="flag label"
        :class="{[code]: true, available: isLanguageAvailable(code)}">
      </router-link>
    </section>

    <section
      v-if="isAdmin"
      class="flex mt-05 w-full">
      <Field
        v-model="newSnip"
        label="Add new"
        label10
        class="flex-1"/>
      <Btn
        small
        icon="plus"
        @click.native="saveNew"/>
    </section>

    <a
      v-if="this.available.length"
      class="tcyan inline-flex mt-1 cursor-pointer mb-1" @click="logout">Logout</a>

  </div>
</template>

<script>
import {mapState} from 'vuex'
import mixinLanguages from '@/mixins/languages'
import Btn from '@/components/basic/Btn'
import Field from '@/components/basic/Field'

export default {
  name: 'Home',
  mixins: [mixinLanguages],
  components: {
    Btn,
    Field
  },
  data: () => ({
    newSnip: ''
  }),
  computed: {
    ...mapState({
      languages: state => state.languages,
      available: state => state.available
    }),
    isAdmin () {
      // empty language means admin
      return this.available.indexOf('') > -1
    }
  },
  methods: {
    isLanguageAvailable (code) {
      return this.available.indexOf(code) > -1
    },
    logout () {
      console.log('Logging out')
      localStorage.removeItem('token')
      location.reload()
    },
    async saveNew () {
      await this.languagesSaveSnip('en', { _id: this.newSnip, en: this.newSnip })
      this.newSnip = ''
    }
  }
}
</script>

<style scoped lang="scss">
section {
  max-width: 54rem;
}
</style>



// WEBPACK FOOTER //
// src/modules/Languages/Home.vue